<k-navbar></k-navbar>
<router-outlet></router-outlet>
